import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "labelField", "hpField", "currentHpField"]
  static values = { url: String }

  connect() {
    this._timer = null
    document.addEventListener("click", this._handleOutsideClick)
  }

  disconnect() {
    clearTimeout(this._timer)
    document.removeEventListener("click", this._handleOutsideClick)
  }

  search() {
    clearTimeout(this._timer)
    const q = this.inputTarget.value.trim()
    if (q.length < 2) {
      this._clearResults()
      return
    }
    this._timer = setTimeout(() => this._fetch(q), 300)
  }

  async _fetch(q) {
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(q)}`
      const resp = await fetch(url, { headers: { "Accept": "application/json" } })
      if (!resp.ok) return
      const monsters = await resp.json()
      this._renderResults(monsters)
    } catch {
      this._clearResults()
    }
  }

  _renderResults(monsters) {
    if (!this.hasResultsTarget) return
    if (monsters.length === 0) {
      this.resultsTarget.innerHTML = '<div class="px-3 py-2 text-tavern-muted text-xs">No matches</div>'
      this.resultsTarget.classList.remove("hidden")
      return
    }
    this.resultsTarget.innerHTML = monsters.map(m =>
      `<button type="button"
               class="w-full text-left px-3 py-1.5 text-sm text-tavern-cream hover:bg-tavern-raised hover:text-tavern-gold transition-colors"
               data-action="click->monster-search#select"
               data-index="${m.index}"
               data-name="${m.name}">
        ${m.name}
      </button>`
    ).join("")
    this.resultsTarget.classList.remove("hidden")
  }

  select(event) {
    const btn = event.currentTarget
    const name = btn.dataset.name
    const index = btn.dataset.index

    this.inputTarget.value = name
    if (this.hasLabelFieldTarget) this.labelFieldTarget.value = name
    this._clearResults()

    // Fetch HP via server-side proxy
    fetch(`${this.urlValue}?index=${encodeURIComponent(index)}`, {
      headers: { "Accept": "application/json" }
    })
      .then(r => r.json())
      .then(data => {
        const hp = data.hit_points || ""
        if (this.hasHpFieldTarget) this.hpFieldTarget.value = hp
        if (this.hasCurrentHpFieldTarget) this.currentHpFieldTarget.value = hp
      })
      .catch(() => {})
  }

  _clearResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = ""
      this.resultsTarget.classList.add("hidden")
    }
  }

  _handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this._clearResults()
    }
  }
}
